const apiBaseUrl = readFromEnv('API_BASE_URL');

const config = {
    API_BASE_URL: apiBaseUrl,
    LABELS_URL: readFromEnv('LABELS_URL'),
    USERS_URL: readFromEnv('USERS_URL'),
    PAYMENT_METHODS_URL: readFromEnv('PAYMENT_METHODS_URL'),
    CARRIER_URL: readFromEnv('CARRIER_URL'),
    ORDERS_URL: readFromEnv('ORDERS_URL'),
    AUTOMATION_URL: readFromEnv('AUTOMATION_URL'),
    BATCHES_URL: readFromEnv('BATCHES_URL'),
    PRODUCTS_URL: readFromEnv('PRODUCTS_URL'),
    ORDER_ANALYTICS_URL: readFromEnv('ORDER_ANALYTICS_URL'),
    WEATHER_IMPACT_URL: readFromEnv('WEATHER_IMPACT_URL'),
    SHIPMENTS_ANALYTICS_URL: readFromEnv('SHIPMENTS_ANALYTICS_URL'),
    TRACKING_RECORDS_URL: readFromEnv('TRACKING_RECORDS_URL'),
    SYNC_JOBS_URL: readFromEnv('SYNC_JOBS_URL'),
    ADJUSTMENT_JOBS_URL: readFromEnv('ADJUSTMENT_JOBS_URL'),
    TRACKING_REPORTS_URL: readFromEnv('TRACKING_REPORTS_URL'),
    TRACKING_EVENTS_URL: readFromEnv('TRACKING_EVENTS_URL'),
    ZONES_ANALYTICS_URL: readFromEnv('ZONES_ANALYTICS_URL'),
    SHIPMENT_FINANCIALS_ANALYTICS_URL: readFromEnv('SHIPMENT_FINANCIALS_ANALYTICS_URL'),
    HEAT_MAP_ANALYTICS_URL: readFromEnv('HEAT_MAP_ANALYTICS_URL'),
    INTEGRATION_SUMMARY_ANALYTICS_URL: readFromEnv('INTEGRATION_SUMMARY_ANALYTICS_URL'),
    CARRIER_OPTIMIZATION_ANALYTICS_URL: readFromEnv('CARRIER_OPTIMIZATION_ANALYTICS_URL'),
    OPERATIONAL_OPTIMIZATION_ANALYTICS_URL: readFromEnv('OPERATIONAL_OPTIMIZATION_ANALYTICS_URL'),
    TRACKING_STATUS_ANALYTICS_URL: readFromEnv('TRACKING_STATUS_ANALYTICS_URL'),
    DELIVERY_PERFORMANCE_ANALYTICS_URL: readFromEnv('DELIVERY_PERFORMANCE_ANALYTICS_URL'),
    TRANSIT_TIMES_ANALYTICS_URL: readFromEnv('TRANSIT_TIMES_ANALYTICS_URL'),
    SURCHARGES_ANALYTICS_URL: readFromEnv('SURCHARGES_ANALYTICS_URL'),
    SURCHARGES_COMPARISON_ANALYTICS_URL: readFromEnv('SURCHARGES_COMPARISON_ANALYTICS_URL'),
    TOTAL_COST_ANALYTICS_URL: readFromEnv('TOTAL_COST_ANALYTICS_URL'),
    SHIPMENT_COMPARISON_ANALYTICS_URL: readFromEnv('SHIPMENT_COMPARISON_ANALYTICS_URL'),
    LOGGER_URL: readFromEnv('LOGGER_URL'),
    RATE_SETS_URL: readFromEnv('RATE_SETS_URL'),
    MANIFESTS_URL: readFromEnv('MANIFESTS_URL'),
    PRICING_URL: readFromEnv('PRICING_URL'),
    INTEGRATIONS_URL: readFromEnv('INTEGRATIONS_URL'),
    JOBS_URL: readFromEnv('JOBS_URL'),
    INTEGRATION_TYPES_URL: readFromEnv('INTEGRATION_TYPES_URL'),
    ANTHROPIC_URL: readFromEnv('ANTHROPIC_URL'),
    JAVA_API_URL: readFromEnv('JAVA_API_URL'),
    SHIPMENTS_URL: readFromEnv('SHIPMENTS_URL'),
    ADJUSTMENTS_URL: readFromEnv('ADJUSTMENTS_URL'),
    AGENTS_URL: readFromEnv('AGENTS_URL'),
    ADDRESSBOOK_URL: readFromEnv('ADDRESSBOOK_URL'),
    AI_CHAT_SERVICE_URL: readFromEnv('AI_CHAT_SERVICE_URL'),
    WAREHOUSES_URL: readFromEnv('WAREHOUSES_URL'),
    LOCATIONS_URL: readFromEnv('LOCATIONS_URL'),
    INVENTORY_URL: readFromEnv('INVENTORY_URL'),
    VERIFY_ADDRESS_URL: readFromEnv('VERIFY_ADDRESS_URL'),
    VERIFY_USPS_SHIP_ADDRESS: readFromEnv('VERIFY_USPS_SHIP_ADDRESS'),
    SECURE_LOCAL_STORAGE_HASH_KEY: readFromEnv('SECURE_LOCAL_STORAGE_HASH_KEY'),
    IMPORT_BATCHES_URL: readFromEnv('IMPORT_BATCHES_URL'),
    STRIPE_PUBLISHABLE_KEY: readFromEnv('STRIPE_PUBLISHABLE_KEY'),
    ENVIRONMENT: readFromEnv('ENVIRONMENT'),
    DEFAULT_REPORT_DATE_RANGE_DAYS: 7,
};

export default config;

///////////////

export function readFromEnv(key) {
    return window[key] === '__' + key + '__' ? process.env['REACT_APP_' + key] : window[key];
}
